export default __webpack_public_path__ + "static/assets/f47c36c5cd26edcbbd1e7a042ff451a0.png";